import {
    useCallback,
    useEffect,
    useState,
} from 'react';

import { Contract } from 'ethers';

import { tokenArr } from '@/collocate';
import FFR_ABI from '@/store/wallet/tools/contract/abi/token.json';
import useConnectWallet from '@/store/wallet/useConnectWallet';

export default function useFFRTokenLP(flag: boolean,) {
    const { signer, provider } = useConnectWallet();
    const [getFFrTokenLPLod, setGetFFrTokenLPLod] = useState(false);
    const [FFRLP, setFFRLP] = useState(BigInt(0))
    const getFFrTokenLP = useCallback(async () => {
        try {
            setGetFFrTokenLPLod(true)
            const FFRCON = new Contract(tokenArr[0].address, FFR_ABI, signer || provider);
            const res = await FFRCON.totalLPs();
            console.log(res);
            setFFRLP(res)
        } catch (error) {
            console.error("Error getting FFR Token LP:", error);
        } finally {
            setGetFFrTokenLPLod(false);
        }
    }, [signer, provider]);
    useEffect(() => {
        flag && getFFrTokenLP()
    }, [flag, getFFrTokenLP])
    return {
        getFFrTokenLPLod,
        FFRLP
    }
}